import { render, staticRenderFns } from "./CargoClaimList.vue?vue&type=template&id=09b741a0&"
import script from "./CargoClaimList.vue?vue&type=script&lang=js&"
export * from "./CargoClaimList.vue?vue&type=script&lang=js&"
import style0 from "./CargoClaimList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CargoClaimList.vue"
export default component.exports